import { cn } from '@/lib/utils'

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-upbo-src="src/components/ui/skeleton.tsx:4" data-slot="skeleton" className={cn('animate-pulse rounded-md bg-accent', className)} {...props} />
}

export { Skeleton }
